import { EcpLocator } from '../ecp-locator-new';
import { Wiki } from '../wiki';
import { SignUpBanner } from '../sign-up-banner';

import { PrimaryBannerUnregistered } from '../primary-banner-unregistered';
import { DownloadApp } from '../../download-app';
import { useStyles } from './landing-page-not-logged-in.styles';
import { Simulator } from '../simulator';
import { v2025PP17764 } from '../../../../../constants/veeva';

export const LandingPageNotLoggedIn = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <SignUpBanner />
      <DownloadApp />
      <PrimaryBannerUnregistered />
      <EcpLocator />
      <div className={classes.simulator}>
        <Simulator />
      </div>
      <div className={classes.veeva}>{v2025PP17764}</div>
      <div className={classes.coloredSection}>
        <Wiki />
      </div>
    </>
  );
};
